// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../../IndicatorConstants';
import { IndicatorFunctions } from '../../IndicatorFunctions';
import { IBearsPower } from './iBearsPower';
export const iBullsPower = 'iBullsPower';
export class IBullsPower extends IBearsPower {
    get Name() {
        return iBullsPower;
    }
    OnQuote() {
        const price = this.GetPrice(this.FPriceType, 0);
        this.FEMA[this.FEMA.Length - 1] = price;
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        if (this.FMaPeriod > this.Count - 1) {
            return;
        }
        this.SetValue(this.GetPrice(PriceType.High, 0) -
            IndicatorFunctions.CallMovingFunction(MAMode.EMA, this.FEMA, this.FMaPeriod, 1));
    }
}
